import { Typography } from '@mui/material';
import type { FC } from 'react';

import { useAppDispatch } from 'features/app/hooks';
import { handleError } from 'features/notification/store';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';

interface CallIdBaseProps {
  value: number;
  title: string;
}

export const CallIdBase: FC<CallIdBaseProps> = ({ value, title }) => {
  const dispatch = useAppDispatch();

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(value.toString());
    } catch (error) {
      dispatch(
        handleError({
          error,
          methodName: 'handleCopyToClipboard',
        })
      );
    }
  };

  return (
    <Container>
      <Typography variant='label' color={theme.palette.grey[100]}>
        {title}
      </Typography>
      <CallIdText
        data-testid='call-id'
        variant='body1'
        onClick={handleCopyToClipboard}
      >
        {value}
      </CallIdText>
    </Container>
  );
};

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: ${theme.spacing(8)};
`;

const CallIdText = styled(Typography)`
  cursor: pointer;
  color: ${theme.palette.common.white};
`;
